import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "No sponsors, no sacred cows",
    text: "Neither Microsoft nor Apple pays for a word on this site. When a platform loses a round, we say so in the headline.",
  },
  {
    n: "02",
    title: "Verdicts, always",
    text: "'It depends' is a coward's conclusion. Every dispatch ends with a clear winner for a clearly defined buyer.",
  },
  {
    n: "03",
    title: "Updated as the war moves",
    text: "Silicon ships yearly. Our comparisons are living documents, revised as new hardware and software change the score.",
  },
];

const Manifesto = () => (
  <section className="py-28 md:py-36 border-b border-white/10" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal>
        <p className="font-mono-p text-xs tracking-[0.35em] uppercase text-[#0055FF] mb-4">
          The Manifesto
        </p>
        <h2 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight max-w-3xl">
          Three rules govern every comparison we publish.
        </h2>
      </Reveal>
      <div className="mt-20 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.15} className="bg-[#0A0A0A] p-10 md:p-12">
            <span className="font-oswald text-6xl font-bold text-stroke block mb-8">{c.n}</span>
            <h3 className="font-oswald text-xl tracking-[0.1em] uppercase mb-4">{c.title}</h3>
            <p className="font-mono-p text-sm leading-relaxed text-[#A1A1AA]">{c.text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
